export default __webpack_public_path__ + "static/media/IMG-20250105-WA0014.a039fc6c.jpg";